const benefits = [
  {
    description:
      'A professional address you can assign to clients during company formation or onboarding.',
    title: 'Sydney CBD Business Address',
  },
  {
    description:
      'All mail is scanned, categorised, and securely stored. Our system detects spam, flags critical items, and routes documents accordingly.',
    title: 'Automated Mail & Document Handling',
  },
  {
    description:
      'Whether you use our branded portal or deploy our API, you remain in control. Offer our service under your identity with complete flexibility.',
    title: 'Your Brand, Your Platform',
  },
  {
    description:
      'Support 10 clients or 10,000. The platform is built for scale and backed by over 100 trusted partnerships.',
    title: 'No Limits on Growth',
  },
  {
    description:
      'Set your pricing. Bundle it with formation packages, advisory, or as a standalone add-on.',
    title: 'Margin Control',
  },
  {
    description:
      'We handle all of the details, from receiving and processing the mail through to customer support.',
    title: 'Hassle Free Operations',
  },
]

const EnterpriseBenefits = () => {
  return (
    <div className='d-flex flex-column align-items-center'>
      <h1 className='fs-fluid-36-80 lh-105 fw-semibold text-center'>
        What’s <span className='color-pink2'>Included</span>
      </h1>
      <div
        className='d-flex flex-column mt-6 mt-lg-14 gap-7 gap-lg-5'
        style={{
          maxWidth: 1074,
        }}
      >
        {benefits.map((benefit) => (
          <div key={benefit.title}>
            <h3 className='fs-fluid-16-32 fw-lg-semibold mb-2'>
              {benefit.title}
            </h3>
            <span className='fs-fluid-16-24 fw-semibold color-grey5'>
              {benefit.description}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default EnterpriseBenefits
